import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

export interface ARequestRequest {
    idx: number;
    a_request?: string;
}

export interface ARequestResponse {
    statusCode: number;
    message: string;
}

export const usePutARequest = (
    successCallback?: (data: ARequestResponse) => void,
): UseMutationResult<ARequestResponse, Error, ARequestRequest, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<ARequestResponse, Error, ARequestRequest>({
        mutationFn: async (aRequestData: ARequestRequest) => {
            const response = await axiosInstance.put(enum_api_uri.put_a_request, aRequestData);
            return response.data;
        },
        onSuccess: data => {
            successCallback?.(data);
            queryClient.invalidateQueries({ queryKey: ["usePostTrackingList"] });
        },
    });
};
